export default __webpack_public_path__ + "static/media/md8-maintenance.45118d9c.svg";